'use strict';

let currentURL;
const variantSelector = document.querySelector('.rio-options');
const nav = document.querySelector('.header__inline-menu');
const linkDYR = document.querySelector('.design-rug');
const btnSaveRugField = document.querySelector('.btn-save-rug-field');
const btnSaveBorder = document.querySelector('.btn-save-border');
const btnSaveWallcovering = document.querySelector('.btn-save-wallcovering');
const mediaGallery = document.querySelector('.rio-media-gallery');
const updateMessage = document.querySelector('.update-message');
const variantPattern = document.getElementById('variant-pattern');
const variantPatternRepeat = document.getElementById('variant-pattern-repeat');
const variantBacking = document.getElementById('variant-backing');
const variantConstruction = document.getElementById('variant-construction');
const variantComposition = document.getElementById('variant-composition');
const variantWidth = document.getElementById('variant-width');
const productTabNav = document.querySelector('.main-product-tab__nav');
const outletTabContent = document.querySelector('.outlet-tab__content');
const outletMobileNavs = document.querySelectorAll('.outlet-tab__mobile-nav-container');
const inventoryQty = document.querySelector('.inventory-quantity__number');

localStorage.removeItem('selectedVariant');

const outletTabSwitch = function(str) {
  document.querySelectorAll('.outlet-tab__content-item').forEach(el => el.classList.remove('outlet-tab__content-item--active'))
  outletTabContent.querySelector(`.${str}`).closest('.outlet-tab__content-item').classList.add('outlet-tab__content-item--active')
}

const outletTabSwitchMobile = function(str) {
  outletTabContent.querySelector(`.${str}`).closest('.outlet-tab__content-item').classList.toggle('outlet-tab__content-item--mobile-active')
}

const getCaption = function(url, prod, index) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type':'application/json',
      'X-Shopify-Storefront-Access-Token':'f9f28e22142146072bb46fa427213264'
    },
    body: JSON.stringify({
      query: `{
      product(id: "gid:\/\/shopify\/Product\/${prod}") {
      title
      variants(first: 50) {
      nodes {
      sku
      title
      id
      metafield(namespace: "custom", key: "image_captions") {
      value
      }
      }
      }
      }
      }
      `
    })
  }).then(res => {
   if (!res.ok) console.log(res);
    return res.json()
  }).then(data => {
    console.log(data);
    const productTitle = data.data.product.title;
    const variantSKU = data.data.product.variants.nodes.find(el => el.id === `gid://shopify/ProductVariant/${selectedVariantID}`).sku ? ` ${data.data.product.variants.nodes.find(el => el.id === `gid://shopify/ProductVariant/${selectedVariantID}`).sku}` : false;
    const variantTitle = data.data.product.variants.nodes.find(el => el.id === `gid://shopify/ProductVariant/${selectedVariantID}`).title;
    const materialCaption = `${productTitle}${variantSKU ? variantSKU : ''} ${variantTitle}`;
    console.log(materialCaption);
    const metafieldValue = data.data.product.variants.nodes.find(el => el.id === `gid://shopify/ProductVariant/${selectedVariantID}`).metafield?.value ?? "[]";
    const captionArray = JSON.parse(metafieldValue);
    return [materialCaption, ...captionArray][index] || '';
  })
}

const grabURLDelay = function() {
  setTimeout(function() {
    currentURL = window.location.href;
    selectedVariantID = currentURL.split('variant=')[1];
    updateVariant();
    changeCaption(0);
  }, 200
  )
}

const grabURL = function() {
  if (!window.location.href.includes('variant=')) return;
  currentURL = window.location.href;
  selectedVariantID = currentURL.split('variant=')[1];
}

const getInventoryQty = async function(itemNumber) {
  if (!itemNumber) {
    inventoryQty.classList.remove("green", "orange");
    return inventoryQty.textContent = "Data Not Available"
  }
  try {
    const url = `https://fibreworks-customer-app.azurewebsites.net/api/v1/sql/item-qty?itemNumber=${itemNumber}`;
    const data = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json'
          }
        }).then((res) => res.json()).then(res => {
          if (res.status === 'success') {
            return res;
          } else {
            console.log(res.message)
          }
        });
    if (!data.data?.ITEMNMBR ?? null) return inventoryQty.textContent = "Data Not Available";
    const goodLotAvail = data.lotData.some(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC > 50);
    const goodLots = data.lotData.filter(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC > 25);
    const totalOfGoodLots = goodLots.map(lot => lot.SUMQTYRECVD - lot.SUMQTYSOLD - lot.SUMATYALLOC).reduce((acc, lotQty) => acc + lotQty, 0) - data.data.ATYALLOC;
    // const totalAvail = data.data.QTYONHND - data.data.ATYALLOC;
    if (inventoryQty && totalOfGoodLots > 50) {
      inventoryQty.classList.add("green");
      inventoryQty.classList.remove("orange");
      inventoryQty.textContent = totalOfGoodLots > 120 ? "Available" : "Limited Availability"
    } else {
      inventoryQty.classList.remove("green");
      inventoryQty.classList.add("orange");
      inventoryQty.textContent = `Contact Account Manager for Availability`
    }
  } catch (err) {
    console.error(err)
    inventoryQty.textContent = "Data updating...";
    setTimeout(() => {
      getInventoryQty(itemNumber)
    }, 10000);
  }
}

const setStorage = function() {
  localStorage.setItem('selectedVariant', JSON.stringify({product: thisProduct.camel, variant: thisProduct.variants[selectedVariantID].title, productID: thisProduct.id, variantID: thisProduct.variants[selectedVariantID].id, excludeSerging: thisProduct.variants[selectedVariantID].excludeSerging, rugPadOptions: thisProduct.variants[selectedVariantID].rugPadOptions}))
}

const removeStorage = function(e) {
  if (!e.target.href === '/pages/design-your-rug') return;
  localStorage.removeItem('selectedVariant');
}

const saveRugField = function() {
  const productID = thisProduct.id;
  const variantID = thisProduct.variants[selectedVariantID].id;
  const newRugField = {product: thisProduct.id, variant: Number(selectedVariantID)};
  if (savedRugFields.some(obj => obj.variant === newRugField.variant)) {
  } else {
    savedRugFields.push(newRugField);
  }
  ravenSubmit(JSON.stringify(savedRugFields));
}

const saveBorder = function() {
  const productID = thisProduct.id;
  const variantID = thisProduct.variants[selectedVariantID].id;
  const newBorder = {product: productID, variant: variantID};
  if (savedBorders.some(obj => obj === newBorder)) {
  } else {
    savedBorders.push(newBorder);
  }
  ravenSubmitBorder(JSON.stringify(savedBorders));
}

const saveWallcovering = function() {
  const productID = thisProduct.id;
  const variantID = thisProduct.variants[selectedVariantID].id;
  const newWallcovering = {product: productID, variant: variantID};
  if (savedWallcoverings.some(obj => obj === newWallcovering)) {
  } else {
    savedWallcoverings.push(newWallcovering);
  }
  ravenSubmitWallcovering(JSON.stringify(savedWallcoverings));
}

const changeCaption = async function(index) {
  const caption = await getCaption(`/api/2024-01/graphql.json`, thisProduct.id, index);
  const thumbScroll = document.querySelector('.pwzrjss2');
  const media = document.querySelector('.pwzrjss1');
  const image__caption = document.querySelector('.image__caption');
  if (image__caption) return image__caption.textContent = caption;
  thumbScroll ? thumbScroll.insertAdjacentHTML('afterend', `<p class="image__caption">${caption}</p>`) : media.insertBefore(`<p class="image__caption">${caption}</p>`, media.childNodes[1]);
  // if (thumbScroll) {
  //   image__caption ? image__caption.textContent = caption : thumbScroll.insertAdjacentHTML('afterend', `<p class="image__caption">${caption}</p>`);
  // } else {
  //   image__caption ? image__caption.textContent = caption : media.insertBefore(`<p class="image__caption">${caption}</p>`, media.childNodes[1]);
  // }
}

const updateVariant = function() {
  if (document.querySelector('.form')) document.querySelector('.form').querySelector('[name="id"]').value = selectedVariantID;
  if (variantPattern) variantPattern.textContent = thisProduct.variants[selectedVariantID].pattern.join(', ');
  if (variantPatternRepeat) variantPatternRepeat.textContent = thisProduct.variants[selectedVariantID].patternRepeat;
  if (variantBacking) variantBacking.textContent = thisProduct.variants[selectedVariantID].backing;
  if (variantConstruction) variantConstruction.textContent = thisProduct.variants[selectedVariantID].construction;
  if (variantComposition) variantComposition.textContent = thisProduct.variants[selectedVariantID].fiberComposition;
  if (variantWidth) variantWidth.textContent = `${String(thisProduct.variants[selectedVariantID].width).split('.')[0]}'${Math.round(Number('.' + String(thisProduct.variants[selectedVariantID].width).split('.')[1])*12) || 0}''`;
  if (inventoryQty) inventoryQty.classList.remove("green", "orange");
  if (inventoryQty) inventoryQty.textContent = 'Loading...';
  if (inventoryQty) getInventoryQty(thisProduct.variants[selectedVariantID].itemNumber ?? null);
}


const showUpdateEl = function(message, type) {
  updateMessage.textContent = message || 'Rug Updated';
  updateMessage.classList.add('show-update', type);
  setTimeout(() => updateMessage.classList.remove('show-update'), 1500);
}

if (productTabNav) {
  productTabNav.addEventListener('click', function(e) {
    const selection = e.target.closest('.outlet-tab__list-item');
    if (!selection) return;
    document.querySelectorAll('.outlet-tab__list-item').forEach(el => el.classList.remove('active'));
    selection.classList.add('active');
    const section = selection.getAttribute('data-content-ref');
    outletTabSwitch(section);
  });
}

outletMobileNavs.forEach(el => {
  el.addEventListener('click', function(e) {
    const selection = e.target.closest('.outlet-tab__mobile-nav-container');
    if (!selection) return;
    selection.classList.toggle('active');
    const section = selection.getAttribute('data-content-ref');
    outletTabSwitchMobile(section);
  })
})

window.addEventListener('locationchange', function() {
  if (currentURL === window.location.href) return;
  grabURLDelay()
  // changeCaption(0);
});
// variantSelector.addEventListener('click', grabURLDelay);
nav.addEventListener('click', removeStorage);
if (linkDYR) linkDYR.addEventListener('click', setStorage);

mediaGallery.addEventListener('click', function(e) {
  // if (!e.target.closest('div').getAttribute('role') === 'button') return;
  const thumbnailIndex = [...mediaGallery.querySelectorAll('[role="button"] img')].indexOf(e.target);
  if (thumbnailIndex < 0) return;
  changeCaption(thumbnailIndex);
});

grabURL();
updateVariant();
changeCaption(0);